"use client";

import { useLocale, useTranslations } from "next-intl";
import NotFoundContent from "@/components/NotFoundContent";

export default function NotFound() {
  const locale = useLocale();
  const t = useTranslations("notFoundPage");

  return (
    <NotFoundContent
      homeHref={`/${locale}`}
      copy={{
        title: t("title"),
        description: t("description"),
        // `raw` y no `t(...)`: hace falta la plantilla con `{seconds}` sin
        // resolver, para que la cuenta regresiva la sustituya cada segundo.
        redirect: t.raw("redirect") as string,
        cancel: t("cancel"),
        cancelled: t("cancelled"),
        goHome: t("goHome"),
      }}
    />
  );
}
